import { defineComponent, computed } from "@vue/composition-api";
import { routeParamsBuilder } from "@/views/helpers";
import { NamedRts } from "@/router";
import { ActiveNavMenuSetting } from "@/store/modules/session";
import { format } from "date-fns";
import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "cssGrid",
  setup(_props, ctx) {
    let $store = ctx.root.$store;

    const companyName = computed(() => {
      return $store.getters.companyName;
    });

    const activeNavMenu = computed(() => {
      return $store.getters.activeNavMenu;
    });

    const activeLink = (rtParams: { name: string }) => {
      return rtParams.name === ctx.root.$route.name;
    };

    const setMainMenu = () => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.main);
    };

    const createWorkOrderCopy = () => {
      const jsConn = new JSConn();
      const td = format(new Date(), "yyyy-MM-dd");

      jsConn.formParams = {
        work_order_id: workOrder.value.id,
        submitted_date: td,
      };

      $store.dispatch("createWorkOrderFromWorkOrder", jsConn).then(() => {
        setMainMenu();
        ctx.root.$router.push({
          name: "workOrders",
        });
        return Promise.resolve();
      });
    };

    let workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    const setWorkOrderMenu = () => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.workOrder);
    };

    const isWorkOrderShow = computed(() => {
      return (
        ctx.root.$route.name === NamedRts.workOrderShow ||
        ctx.root.$route.name === NamedRts.workOrderTasks ||
        ctx.root.$route.name === NamedRts.workOrderPrint ||
        ctx.root.$route.name === NamedRts.workOrderDetails
      );
    });

    const setInventoryLotMenu = () => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.inventoryLot);
    };

    const setSellContractMenu = () => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.sellContract);
    };

    const isSellContractShow = computed(() => {
      return (
        ctx.root.$route.name === NamedRts.sellContractShow ||
        ctx.root.$route.name === NamedRts.sellContractDetails ||
        ctx.root.$route.name === NamedRts.sellContractIlsctlLineItems
      );
    });

    const isInventoryLotShow = computed(() => {
      return (
        ctx.root.$route.name === NamedRts.inventoryLotShow ||
        ctx.root.$route.name === NamedRts.inventoryLotDetails ||
        ctx.root.$route.name === NamedRts.inventoryLotIlsctlLineItems
      );
    });

    const routeParams = routeParamsBuilder();

    const scrollToTop = () => {
      let element = document.querySelector("#top-of-page");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    };

    return {
      routeParams,
      activeLink,
      companyName,
      activeNavMenu,

      setMainMenu,
      setWorkOrderMenu,
      isWorkOrderShow,
      workOrder,
      createWorkOrderCopy,

      isInventoryLotShow,
      setInventoryLotMenu,

      isSellContractShow,
      setSellContractMenu,

      scrollToTop,
    };
  },
});
